import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

const HomeValueFilterIcon = (props: any) => {
  const theme = useContext(ThemeContext);
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18.5834 11.5L14.625 15.4583L12.5417 13.375L9.41669 16.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M16.0833 11.5H18.5833V14" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M1 7.41404L7.61254 1.74603C8.12321 1.30829 8.87678 1.30829 9.38746 1.74603L16 7.41404"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9286 6.51051V1.68182C14.9286 1.50099 14.8568 1.32756 14.7289 1.1997C14.6011 1.07183 14.4276 1 14.2468 1H12.2013C11.8248 1 11.5195 1.30526 11.5195 1.68182V3.58833"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.4541 15.168V10.8498C6.4541 10.4732 6.7595 10.168 7.13621 10.168H8.50041"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M2.07114 6.51172V15.1679" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M7 15.6667H1"
        stroke={theme.colors.primary.c500}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HomeValueFilterIcon;
